import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'version',
      label: i18n.t('common_words.version'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'device_types.name',
      label: i18n.t('devices.devices_type'),
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
